import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

/**
 * A wrapper component that adds a tooltip to any element
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child elements to wrap with tooltip
 * @param {string} props.title - Tooltip text
 * @param {string} props.placement - Tooltip placement (top, bottom, left, right)
 * @param {Object} props.sx - Additional styles for the wrapper
 * @returns {React.ReactElement} Tooltip wrapped component
 */
const TooltipWrapper = ({ 
  children, 
  title, 
  placement = 'top',
  showIcon = false,
  iconSize = 'small',
  sx = {} 
}) => {
  if (!title) return children;
  
  if (showIcon) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', ...sx }}>
        {children}
        <Tooltip title={title} placement={placement} arrow>
          <IconButton size={iconSize} sx={{ ml: 0.5, p: 0.5 }}>
            <HelpOutlineIcon fontSize={iconSize} color="action" />
          </IconButton>
        </Tooltip>
      </span>
    );
  }
  
  return (
    <Tooltip title={title} placement={placement} arrow>
      <span style={{ ...sx }}>
        {children}
      </span>
    </Tooltip>
  );
};

export default TooltipWrapper;